<template>
    <div class="inline-flex space-x-4" :dusk="dusk">
        <label v-for="option in options" :key="option.id" class="inline-flex items-center space-x-2">
            <adminRadio v-model="modelValue" :value="option.id" :size="size" :required="required"> </adminRadio>
            <span class="text-sm">
                {{ option.name }}
            </span>
        </label>
    </div>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const props = defineProps<FieldComponent>();

const emit = defineEmits(['update:modelValue']);

const modelValue = computed({
    get: () => props.modelValue,
    set: (val: string | number) => emit('update:modelValue', val),
});

const options = toRef(props, 'options');
</script>
